export const NEW_ANALYS_TEMPLATE_NAME = 'Ny analys-kolumner';

interface ITemplateData {
  ekanalyscolumntemplates: IColumnTemplate[];
}

interface IColumnTemplate {
  category: string;
  name: string;
  canHavePrevYearCols: boolean;
  columns: ITemplateColumn[];
}

interface ITemplateColumn {
  rubrik1: string | null;
  rubrik2: string | null;
  rubrik3: string | null;
  faltKod: string;
  faltKodRubrik: string | null;
  resultatTyp: string | null;
  faltTyp: number; // Ska denna vara en enum?
  intervallTyp: number; // Ska denna vara en enum?
  bas: string; // Ska denna vara en enum?
  antalDecimaler: number;
  vandTecken: boolean;
  budgetTyp: BudgetTyp;
  budgetBenamning: string | null;
  fromAr: number;
  fromArRelativ: boolean;
  tomAr: number;
  tomArRelativ: boolean;
  fromPer: number;
  fromPerRelativ: boolean;
  tomPer: number;
  tomPerRelativ: boolean;
  rullande: boolean;
  synlig: boolean;
}

// 'A' = Alla
type BudgetTyp = 'A' | null;

export const templateData: ITemplateData = {
  ekanalyscolumntemplates: [
    {
      category: 'Standard',
      name: NEW_ANALYS_TEMPLATE_NAME,
      canHavePrevYearCols: false,
      columns: [
        {
          rubrik1: null,
          rubrik2: null,
          rubrik3: null,
          faltKod: 'PERINGVARDE',
          faltKodRubrik: null,
          resultatTyp: null,
          faltTyp: 0,
          intervallTyp: 0,
          bas: '1',
          antalDecimaler: 2,
          vandTecken: false,
          budgetTyp: null,
          budgetBenamning: null,
          fromAr: 0,
          fromArRelativ: true,
          tomAr: 0,
          tomArRelativ: true,
          fromPer: 0,
          fromPerRelativ: true,
          tomPer: 0,
          tomPerRelativ: true,
          rullande: false,
          synlig: true,
        },
        {
          rubrik1: null,
          rubrik2: null,
          rubrik3: null,
          faltKod: 'PERVARDE',
          faltKodRubrik: null,
          resultatTyp: null,
          faltTyp: 0,
          intervallTyp: 0,
          bas: '1',
          antalDecimaler: 2,
          vandTecken: false,
          budgetTyp: null,
          budgetBenamning: null,
          fromAr: 0,
          fromArRelativ: true,
          tomAr: 0,
          tomArRelativ: true,
          fromPer: 0,
          fromPerRelativ: true,
          tomPer: 0,
          tomPerRelativ: true,
          rullande: false,
          synlig: true,
        },
        {
          rubrik1: null,
          rubrik2: null,
          rubrik3: null,
          faltKod: 'PERVARDE',
          faltKodRubrik: null,
          resultatTyp: null,
          faltTyp: 1,
          intervallTyp: 0,
          bas: '1',
          antalDecimaler: 2,
          vandTecken: false,
          budgetTyp: null,
          budgetBenamning: null,
          fromAr: 0,
          fromArRelativ: true,
          tomAr: 0,
          tomArRelativ: true,
          fromPer: 0,
          fromPerRelativ: true,
          tomPer: 0,
          tomPerRelativ: true,
          rullande: false,
          synlig: false,
        },
        {
          rubrik1: null,
          rubrik2: null,
          rubrik3: null,
          faltKod: 'PERVARDE',
          faltKodRubrik: null,
          resultatTyp: null,
          faltTyp: 2,
          intervallTyp: 0,
          bas: '1',
          antalDecimaler: 2,
          vandTecken: false,
          budgetTyp: null,
          budgetBenamning: null,
          fromAr: 0,
          fromArRelativ: true,
          tomAr: 0,
          tomArRelativ: true,
          fromPer: 0,
          fromPerRelativ: true,
          tomPer: 0,
          tomPerRelativ: true,
          rullande: false,
          synlig: false,
        },
        {
          rubrik1: null,
          rubrik2: null,
          rubrik3: null,
          faltKod: 'PERUTGVARDE',
          faltKodRubrik: null,
          resultatTyp: null,
          faltTyp: 0,
          intervallTyp: 0,
          bas: '1',
          antalDecimaler: 2,
          vandTecken: false,
          budgetTyp: null,
          budgetBenamning: null,
          fromAr: 0,
          fromArRelativ: true,
          tomAr: 0,
          tomArRelativ: true,
          fromPer: 0,
          fromPerRelativ: true,
          tomPer: 0,
          tomPerRelativ: true,
          rullande: false,
          synlig: true,
        },
        {
          rubrik1: null,
          rubrik2: null,
          rubrik3: null,
          faltKod: 'PERUTGBUDGET',
          faltKodRubrik: null,
          resultatTyp: null,
          faltTyp: 0,
          intervallTyp: 0,
          bas: '1',
          antalDecimaler: 2,
          vandTecken: false,
          budgetTyp: 'A',
          budgetBenamning: null,
          fromAr: 0,
          fromArRelativ: true,
          tomAr: 0,
          tomArRelativ: true,
          fromPer: 0,
          fromPerRelativ: true,
          tomPer: 0,
          tomPerRelativ: true,
          rullande: false,
          synlig: true,
        },
        {
          rubrik1: null,
          rubrik2: null,
          rubrik3: null,
          faltKod: 'DIFFPERUTGVARDEBUDGET',
          faltKodRubrik: null,
          resultatTyp: null,
          faltTyp: 0,
          intervallTyp: 0,
          bas: '1',
          antalDecimaler: 2,
          vandTecken: false,
          budgetTyp: 'A',
          budgetBenamning: null,
          fromAr: 0,
          fromArRelativ: true,
          tomAr: 0,
          tomArRelativ: true,
          fromPer: 0,
          fromPerRelativ: true,
          tomPer: 0,
          tomPerRelativ: true,
          rullande: false,
          synlig: true,
        },
        {
          rubrik1: null,
          rubrik2: null,
          rubrik3: null,
          faltKod: 'PROCENTPERUTGVARDEBUDGET',
          faltKodRubrik: null,
          resultatTyp: null,
          faltTyp: 0,
          intervallTyp: 0,
          bas: '1',
          antalDecimaler: 2,
          vandTecken: false,
          budgetTyp: 'A',
          budgetBenamning: null,
          fromAr: 0,
          fromArRelativ: true,
          tomAr: 0,
          tomArRelativ: true,
          fromPer: 0,
          fromPerRelativ: true,
          tomPer: 0,
          tomPerRelativ: true,
          rullande: false,
          synlig: true,
        },
        {
          rubrik1: null,
          rubrik2: null,
          rubrik3: null,
          faltKod: 'PERUTGBUDGET',
          faltKodRubrik: null,
          resultatTyp: null,
          faltTyp: 0,
          intervallTyp: 0,
          bas: '1',
          antalDecimaler: 2,
          vandTecken: false,
          budgetTyp: 'A',
          budgetBenamning: null,
          fromAr: 1,
          fromArRelativ: true,
          tomAr: 1,
          tomArRelativ: true,
          fromPer: 0,
          fromPerRelativ: true,
          tomPer: 0,
          tomPerRelativ: true,
          rullande: false,
          synlig: false,
        },

        {
          rubrik1: null,
          rubrik2: null,
          rubrik3: null,
          faltKod: 'PERINGVARDE',
          faltKodRubrik: null,
          resultatTyp: null,
          faltTyp: 0,
          intervallTyp: 0,
          bas: '1',
          antalDecimaler: 2,
          vandTecken: false,
          budgetTyp: null,
          budgetBenamning: null,
          fromAr: -1,
          fromArRelativ: true,
          tomAr: -1,
          tomArRelativ: true,
          fromPer: 0,
          fromPerRelativ: true,
          tomPer: 0,
          tomPerRelativ: true,
          rullande: false,
          synlig: false,
        },
        {
          rubrik1: null,
          rubrik2: null,
          rubrik3: null,
          faltKod: 'PERVARDE',
          faltKodRubrik: null,
          resultatTyp: null,
          faltTyp: 0,
          intervallTyp: 0,
          bas: '1',
          antalDecimaler: 2,
          vandTecken: false,
          budgetTyp: null,
          budgetBenamning: null,
          fromAr: -1,
          fromArRelativ: true,
          tomAr: -1,
          tomArRelativ: true,
          fromPer: 0,
          fromPerRelativ: true,
          tomPer: 0,
          tomPerRelativ: true,
          rullande: false,
          synlig: false,
        },
        {
          rubrik1: null,
          rubrik2: null,
          rubrik3: null,
          faltKod: 'PERVARDE',
          faltKodRubrik: null,
          resultatTyp: null,
          faltTyp: 1,
          intervallTyp: 0,
          bas: '1',
          antalDecimaler: 2,
          vandTecken: false,
          budgetTyp: null,
          budgetBenamning: null,
          fromAr: -1,
          fromArRelativ: true,
          tomAr: -1,
          tomArRelativ: true,
          fromPer: 0,
          fromPerRelativ: true,
          tomPer: 0,
          tomPerRelativ: true,
          rullande: false,
          synlig: false,
        },
        {
          rubrik1: null,
          rubrik2: null,
          rubrik3: null,
          faltKod: 'PERVARDE',
          faltKodRubrik: null,
          resultatTyp: null,
          faltTyp: 2,
          intervallTyp: 0,
          bas: '1',
          antalDecimaler: 2,
          vandTecken: false,
          budgetTyp: null,
          budgetBenamning: null,
          fromAr: -1,
          fromArRelativ: true,
          tomAr: -1,
          tomArRelativ: true,
          fromPer: 0,
          fromPerRelativ: true,
          tomPer: 0,
          tomPerRelativ: true,
          rullande: false,
          synlig: false,
        },
        {
          rubrik1: null,
          rubrik2: null,
          rubrik3: null,
          faltKod: 'PERUTGVARDE',
          faltKodRubrik: null,
          resultatTyp: null,
          faltTyp: 0,
          intervallTyp: 0,
          bas: '1',
          antalDecimaler: 2,
          vandTecken: false,
          budgetTyp: null,
          budgetBenamning: null,
          fromAr: -1,
          fromArRelativ: true,
          tomAr: -1,
          tomArRelativ: true,
          fromPer: 0,
          fromPerRelativ: true,
          tomPer: 0,
          tomPerRelativ: true,
          rullande: false,
          synlig: true,
        },
        {
          rubrik1: null,
          rubrik2: null,
          rubrik3: null,
          faltKod: 'PERUTGBUDGET',
          faltKodRubrik: null,
          resultatTyp: null,
          faltTyp: 0,
          intervallTyp: 0,
          bas: '1',
          antalDecimaler: 2,
          vandTecken: false,
          budgetTyp: 'A',
          budgetBenamning: null,
          fromAr: -1,
          fromArRelativ: true,
          tomAr: -1,
          tomArRelativ: true,
          fromPer: 0,
          fromPerRelativ: true,
          tomPer: 0,
          tomPerRelativ: true,
          rullande: false,
          synlig: false,
        },
        {
          rubrik1: null,
          rubrik2: null,
          rubrik3: null,
          faltKod: 'DIFFPERUTGVARDEBUDGET',
          faltKodRubrik: null,
          resultatTyp: null,
          faltTyp: 0,
          intervallTyp: 0,
          bas: '1',
          antalDecimaler: 2,
          vandTecken: false,
          budgetTyp: 'A',
          budgetBenamning: null,
          fromAr: -1,
          fromArRelativ: true,
          tomAr: -1,
          tomArRelativ: true,
          fromPer: 0,
          fromPerRelativ: true,
          tomPer: 0,
          tomPerRelativ: true,
          rullande: false,
          synlig: false,
        },
        {
          rubrik1: null,
          rubrik2: null,
          rubrik3: null,
          faltKod: 'PROCENTPERUTGVARDEBUDGET',
          faltKodRubrik: null,
          resultatTyp: null,
          faltTyp: 0,
          intervallTyp: 0,
          bas: '1',
          antalDecimaler: 2,
          vandTecken: false,
          budgetTyp: 'A',
          budgetBenamning: null,
          fromAr: -1,
          fromArRelativ: true,
          tomAr: -1,
          tomArRelativ: true,
          fromPer: 0,
          fromPerRelativ: true,
          tomPer: 0,
          tomPerRelativ: true,
          rullande: false,
          synlig: false,
        },
      ],
    },
    {
      category: 'Standard',
      name: 'Datum',
      canHavePrevYearCols: false,
      columns: [
        {
          rubrik1: null,
          rubrik2: null,
          rubrik3: null,
          faltKod: 'PERINGVARDE',
          faltKodRubrik: null,
          resultatTyp: null,
          faltTyp: 0,
          intervallTyp: 1,
          bas: '1',
          antalDecimaler: 2,
          vandTecken: false,
          budgetTyp: null,
          budgetBenamning: null,
          fromAr: 0,
          fromArRelativ: true,
          tomAr: 0,
          tomArRelativ: true,
          fromPer: 0,
          fromPerRelativ: true,
          tomPer: 0,
          tomPerRelativ: true,
          rullande: false,
          synlig: true,
        },
        {
          rubrik1: null,
          rubrik2: null,
          rubrik3: null,
          faltKod: 'PERVARDE',
          faltKodRubrik: null,
          resultatTyp: null,
          faltTyp: 0,
          intervallTyp: 1,
          bas: '1',
          antalDecimaler: 2,
          vandTecken: false,
          budgetTyp: null,
          budgetBenamning: null,
          fromAr: 0,
          fromArRelativ: true,
          tomAr: 0,
          tomArRelativ: true,
          fromPer: 0,
          fromPerRelativ: true,
          tomPer: 0,
          tomPerRelativ: true,
          rullande: false,
          synlig: true,
        },
        {
          rubrik1: null,
          rubrik2: null,
          rubrik3: null,
          faltKod: 'PERUTGVARDE',
          faltKodRubrik: null,
          resultatTyp: null,
          faltTyp: 0,
          intervallTyp: 1,
          bas: '1',
          antalDecimaler: 2,
          vandTecken: false,
          budgetTyp: null,
          budgetBenamning: null,
          fromAr: 0,
          fromArRelativ: true,
          tomAr: 0,
          tomArRelativ: true,
          fromPer: 0,
          fromPerRelativ: true,
          tomPer: 0,
          tomPerRelativ: true,
          rullande: false,
          synlig: true,
        },
      ],
    },
    {
      category: 'Standard',
      name: 'Femårsöversikt',
      canHavePrevYearCols: false,
      columns: [
        {
          rubrik1: null,
          rubrik2: null,
          rubrik3: null,
          faltKod: 'ARETSVARDE',
          faltKodRubrik: null,
          resultatTyp: null,
          faltTyp: 0,
          intervallTyp: 0,
          bas: '1',
          antalDecimaler: 2,
          vandTecken: false,
          budgetTyp: null,
          budgetBenamning: null,
          fromAr: -4,
          fromArRelativ: true,
          tomAr: -4,
          tomArRelativ: true,
          fromPer: 0,
          fromPerRelativ: true,
          tomPer: 0,
          tomPerRelativ: true,
          rullande: false,
          synlig: true,
        },
        {
          rubrik1: null,
          rubrik2: null,
          rubrik3: null,
          faltKod: 'ARETSVARDE',
          faltKodRubrik: null,
          resultatTyp: null,
          faltTyp: 0,
          intervallTyp: 0,
          bas: '1',
          antalDecimaler: 2,
          vandTecken: false,
          budgetTyp: null,
          budgetBenamning: null,
          fromAr: -3,
          fromArRelativ: true,
          tomAr: -3,
          tomArRelativ: true,
          fromPer: 0,
          fromPerRelativ: true,
          tomPer: 0,
          tomPerRelativ: true,
          rullande: false,
          synlig: true,
        },
        {
          rubrik1: null,
          rubrik2: null,
          rubrik3: null,
          faltKod: 'ARETSVARDE',
          faltKodRubrik: null,
          resultatTyp: null,
          faltTyp: 0,
          intervallTyp: 0,
          bas: '1',
          antalDecimaler: 2,
          vandTecken: false,
          budgetTyp: null,
          budgetBenamning: null,
          fromAr: -2,
          fromArRelativ: true,
          tomAr: -2,
          tomArRelativ: true,
          fromPer: 0,
          fromPerRelativ: true,
          tomPer: 0,
          tomPerRelativ: true,
          rullande: false,
          synlig: true,
        },
        {
          rubrik1: null,
          rubrik2: null,
          rubrik3: null,
          faltKod: 'ARETSVARDE',
          faltKodRubrik: null,
          resultatTyp: null,
          faltTyp: 0,
          intervallTyp: 0,
          bas: '1',
          antalDecimaler: 2,
          vandTecken: false,
          budgetTyp: null,
          budgetBenamning: null,
          fromAr: -1,
          fromArRelativ: true,
          tomAr: -1,
          tomArRelativ: true,
          fromPer: 0,
          fromPerRelativ: true,
          tomPer: 0,
          tomPerRelativ: true,
          rullande: false,
          synlig: true,
        },
        {
          rubrik1: null,
          rubrik2: null,
          rubrik3: null,
          faltKod: 'ARETSVARDE',
          faltKodRubrik: null,
          resultatTyp: null,
          faltTyp: 0,
          intervallTyp: 0,
          bas: '1',
          antalDecimaler: 2,
          vandTecken: false,
          budgetTyp: null,
          budgetBenamning: null,
          fromAr: 0,
          fromArRelativ: true,
          tomAr: 0,
          tomArRelativ: true,
          fromPer: 0,
          fromPerRelativ: true,
          tomPer: 0,
          tomPerRelativ: true,
          rullande: false,
          synlig: true,
        },
      ],
    },
    {
      category: 'Standard',
      name: 'Kvartalsöversikt',
      canHavePrevYearCols: true,
      columns: [
        {
          rubrik1: null,
          rubrik2: null,
          rubrik3: null,
          faltKod: 'PERVARDE',
          faltKodRubrik: null,
          resultatTyp: null,
          faltTyp: 0,
          intervallTyp: 0,
          bas: '1',
          antalDecimaler: 2,
          vandTecken: false,
          budgetTyp: null,
          budgetBenamning: null,
          fromAr: 0,
          fromArRelativ: true,
          tomAr: 0,
          tomArRelativ: true,
          fromPer: -11,
          fromPerRelativ: true,
          tomPer: -9,
          tomPerRelativ: true,
          rullande: true,
          synlig: true,
        },
        {
          rubrik1: null,
          rubrik2: null,
          rubrik3: null,
          faltKod: 'PERVARDE',
          faltKodRubrik: null,
          resultatTyp: null,
          faltTyp: 0,
          intervallTyp: 0,
          bas: '1',
          antalDecimaler: 2,
          vandTecken: false,
          budgetTyp: null,
          budgetBenamning: null,
          fromAr: 0,
          fromArRelativ: true,
          tomAr: 0,
          tomArRelativ: true,
          fromPer: -8,
          fromPerRelativ: true,
          tomPer: -6,
          tomPerRelativ: true,
          rullande: true,
          synlig: true,
        },
        {
          rubrik1: null,
          rubrik2: null,
          rubrik3: null,
          faltKod: 'PERVARDE',
          faltKodRubrik: null,
          resultatTyp: null,
          faltTyp: 0,
          intervallTyp: 0,
          bas: '1',
          antalDecimaler: 2,
          vandTecken: false,
          budgetTyp: null,
          budgetBenamning: null,
          fromAr: 0,
          fromArRelativ: true,
          tomAr: 0,
          tomArRelativ: true,
          fromPer: -5,
          fromPerRelativ: true,
          tomPer: -3,
          tomPerRelativ: true,
          rullande: true,
          synlig: true,
        },
        {
          rubrik1: null,
          rubrik2: null,
          rubrik3: null,
          faltKod: 'PERVARDE',
          faltKodRubrik: null,
          resultatTyp: null,
          faltTyp: 0,
          intervallTyp: 0,
          bas: '1',
          antalDecimaler: 2,
          vandTecken: false,
          budgetTyp: null,
          budgetBenamning: null,
          fromAr: 0,
          fromArRelativ: true,
          tomAr: 0,
          tomArRelativ: true,
          fromPer: -2,
          fromPerRelativ: true,
          tomPer: 0,
          tomPerRelativ: true,
          rullande: true,
          synlig: true,
        },
      ],
    },
    {
      category: 'Standard',
      name: 'Tertialöversikt',
      canHavePrevYearCols: true,
      columns: [
        {
          rubrik1: null,
          rubrik2: null,
          rubrik3: null,
          faltKod: 'PERVARDE',
          faltKodRubrik: null,
          resultatTyp: null,
          faltTyp: 0,
          intervallTyp: 0,
          bas: '1',
          antalDecimaler: 2,
          vandTecken: false,
          budgetTyp: null,
          budgetBenamning: null,
          fromAr: 0,
          fromArRelativ: true,
          tomAr: 0,
          tomArRelativ: true,
          fromPer: -11,
          fromPerRelativ: true,
          tomPer: -8,
          tomPerRelativ: true,
          rullande: true,
          synlig: true,
        },
        {
          rubrik1: null,
          rubrik2: null,
          rubrik3: null,
          faltKod: 'PERVARDE',
          faltKodRubrik: null,
          resultatTyp: null,
          faltTyp: 0,
          intervallTyp: 0,
          bas: '1',
          antalDecimaler: 2,
          vandTecken: false,
          budgetTyp: null,
          budgetBenamning: null,
          fromAr: 0,
          fromArRelativ: true,
          tomAr: 0,
          tomArRelativ: true,
          fromPer: -7,
          fromPerRelativ: true,
          tomPer: -4,
          tomPerRelativ: true,
          rullande: true,
          synlig: true,
        },
        {
          rubrik1: null,
          rubrik2: null,
          rubrik3: null,
          faltKod: 'PERVARDE',
          faltKodRubrik: null,
          resultatTyp: null,
          faltTyp: 0,
          intervallTyp: 0,
          bas: '1',
          antalDecimaler: 2,
          vandTecken: false,
          budgetTyp: null,
          budgetBenamning: null,
          fromAr: 0,
          fromArRelativ: true,
          tomAr: 0,
          tomArRelativ: true,
          fromPer: -3,
          fromPerRelativ: true,
          tomPer: 0,
          tomPerRelativ: true,
          rullande: true,
          synlig: true,
        },
      ],
    },

    {
      category: 'Standard',
      name: 'Period',
      canHavePrevYearCols: true,
      columns: [
        {
          rubrik1: null,
          rubrik2: null,
          rubrik3: null,
          faltKod: 'PERINGVARDE',
          faltKodRubrik: null,
          resultatTyp: null,
          faltTyp: 0,
          intervallTyp: 0,
          bas: '1',
          antalDecimaler: 2,
          vandTecken: false,
          budgetTyp: null,
          budgetBenamning: null,
          fromAr: 0,
          fromArRelativ: true,
          tomAr: 0,
          tomArRelativ: true,
          fromPer: 0,
          fromPerRelativ: true,
          tomPer: 0,
          tomPerRelativ: true,
          rullande: false,
          synlig: true,
        },
        {
          rubrik1: null,
          rubrik2: null,
          rubrik3: null,
          faltKod: 'PERVARDE',
          faltKodRubrik: null,
          resultatTyp: null,
          faltTyp: 0,
          intervallTyp: 0,
          bas: '1',
          antalDecimaler: 2,
          vandTecken: false,
          budgetTyp: null,
          budgetBenamning: null,
          fromAr: 0,
          fromArRelativ: true,
          tomAr: 0,
          tomArRelativ: true,
          fromPer: 0,
          fromPerRelativ: true,
          tomPer: 0,
          tomPerRelativ: true,
          rullande: false,
          synlig: true,
        },
        {
          rubrik1: null,
          rubrik2: null,
          rubrik3: null,
          faltKod: 'PERVARDE',
          faltKodRubrik: null,
          resultatTyp: null,
          faltTyp: 1,
          intervallTyp: 0,
          bas: '1',
          antalDecimaler: 2,
          vandTecken: false,
          budgetTyp: null,
          budgetBenamning: null,
          fromAr: 0,
          fromArRelativ: true,
          tomAr: 0,
          tomArRelativ: true,
          fromPer: 0,
          fromPerRelativ: true,
          tomPer: 0,
          tomPerRelativ: true,
          rullande: false,
          synlig: false,
        },
        {
          rubrik1: null,
          rubrik2: null,
          rubrik3: null,
          faltKod: 'PERVARDE',
          faltKodRubrik: null,
          resultatTyp: null,
          faltTyp: 2,
          intervallTyp: 0,
          bas: '1',
          antalDecimaler: 2,
          vandTecken: false,
          budgetTyp: null,
          budgetBenamning: null,
          fromAr: 0,
          fromArRelativ: true,
          tomAr: 0,
          tomArRelativ: true,
          fromPer: 0,
          fromPerRelativ: true,
          tomPer: 0,
          tomPerRelativ: true,
          rullande: false,
          synlig: false,
        },
        {
          rubrik1: null,
          rubrik2: null,
          rubrik3: null,
          faltKod: 'PERUTGVARDE',
          faltKodRubrik: null,
          resultatTyp: null,
          faltTyp: 0,
          intervallTyp: 0,
          bas: '1',
          antalDecimaler: 2,
          vandTecken: false,
          budgetTyp: null,
          budgetBenamning: null,
          fromAr: 0,
          fromArRelativ: true,
          tomAr: 0,
          tomArRelativ: true,
          fromPer: 0,
          fromPerRelativ: true,
          tomPer: 0,
          tomPerRelativ: true,
          rullande: false,
          synlig: true,
        },
        {
          rubrik1: null,
          rubrik2: null,
          rubrik3: null,
          faltKod: 'PERUTGBUDGET',
          faltKodRubrik: null,
          resultatTyp: null,
          faltTyp: 0,
          intervallTyp: 0,
          bas: '1',
          antalDecimaler: 2,
          vandTecken: false,
          budgetTyp: 'A',
          budgetBenamning: null,
          fromAr: 0,
          fromArRelativ: true,
          tomAr: 0,
          tomArRelativ: true,
          fromPer: 0,
          fromPerRelativ: true,
          tomPer: 0,
          tomPerRelativ: true,
          rullande: false,
          synlig: true,
        },
        {
          rubrik1: null,
          rubrik2: null,
          rubrik3: null,
          faltKod: 'DIFFPERUTGVARDEBUDGET',
          faltKodRubrik: null,
          resultatTyp: null,
          faltTyp: 0,
          intervallTyp: 0,
          bas: '1',
          antalDecimaler: 2,
          vandTecken: false,
          budgetTyp: 'A',
          budgetBenamning: null,
          fromAr: 0,
          fromArRelativ: true,
          tomAr: 0,
          tomArRelativ: true,
          fromPer: 0,
          fromPerRelativ: true,
          tomPer: 0,
          tomPerRelativ: true,
          rullande: false,
          synlig: true,
        },
        {
          rubrik1: null,
          rubrik2: null,
          rubrik3: null,
          faltKod: 'PROCENTPERUTGVARDEBUDGET',
          faltKodRubrik: null,
          resultatTyp: null,
          faltTyp: 0,
          intervallTyp: 0,
          bas: '1',
          antalDecimaler: 2,
          vandTecken: false,
          budgetTyp: 'A',
          budgetBenamning: null,
          fromAr: 0,
          fromArRelativ: true,
          tomAr: 0,
          tomArRelativ: true,
          fromPer: 0,
          fromPerRelativ: true,
          tomPer: 0,
          tomPerRelativ: true,
          rullande: false,
          synlig: true,
        },
        {
          rubrik1: null,
          rubrik2: null,
          rubrik3: null,
          faltKod: 'PERVARDE',
          faltKodRubrik: null,
          resultatTyp: null,
          faltTyp: 0,
          intervallTyp: 0,
          bas: '1',
          antalDecimaler: 2,
          vandTecken: false,
          budgetTyp: null,
          budgetBenamning: null,
          fromAr: -1,
          fromArRelativ: true,
          tomAr: -1,
          tomArRelativ: true,
          fromPer: 0,
          fromPerRelativ: true,
          tomPer: 0,
          tomPerRelativ: true,
          rullande: false,
          synlig: false,
        },
      ],
    },
    {
      category: 'Standard',
      name: 'Period antal',
      canHavePrevYearCols: true,
      columns: [
        {
          rubrik1: null,
          rubrik2: null,
          rubrik3: null,
          faltKod: 'PERINGVARDE',
          faltKodRubrik: null,
          resultatTyp: null,
          faltTyp: 3,
          intervallTyp: 0,
          bas: '1',
          antalDecimaler: 2,
          vandTecken: false,
          budgetTyp: null,
          budgetBenamning: null,
          fromAr: 0,
          fromArRelativ: true,
          tomAr: 0,
          tomArRelativ: true,
          fromPer: 0,
          fromPerRelativ: true,
          tomPer: 0,
          tomPerRelativ: true,
          rullande: false,
          synlig: true,
        },
        {
          rubrik1: null,
          rubrik2: null,
          rubrik3: null,
          faltKod: 'PERVARDE',
          faltKodRubrik: null,
          resultatTyp: null,
          faltTyp: 3,
          intervallTyp: 0,
          bas: '1',
          antalDecimaler: 2,
          vandTecken: false,
          budgetTyp: null,
          budgetBenamning: null,
          fromAr: 0,
          fromArRelativ: true,
          tomAr: 0,
          tomArRelativ: true,
          fromPer: 0,
          fromPerRelativ: true,
          tomPer: 0,
          tomPerRelativ: true,
          rullande: false,
          synlig: true,
        },
        {
          rubrik1: null,
          rubrik2: null,
          rubrik3: null,
          faltKod: 'PERUTGVARDE',
          faltKodRubrik: null,
          resultatTyp: null,
          faltTyp: 3,
          intervallTyp: 0,
          bas: '1',
          antalDecimaler: 2,
          vandTecken: false,
          budgetTyp: null,
          budgetBenamning: null,
          fromAr: 0,
          fromArRelativ: true,
          tomAr: 0,
          tomArRelativ: true,
          fromPer: 0,
          fromPerRelativ: true,
          tomPer: 0,
          tomPerRelativ: true,
          rullande: false,
          synlig: true,
        },
        {
          rubrik1: null,
          rubrik2: null,
          rubrik3: null,
          faltKod: 'PERUTGBUDGET',
          faltKodRubrik: null,
          resultatTyp: null,
          faltTyp: 3,
          intervallTyp: 0,
          bas: '1',
          antalDecimaler: 2,
          vandTecken: false,
          budgetTyp: 'A',
          budgetBenamning: null,
          fromAr: 0,
          fromArRelativ: true,
          tomAr: 0,
          tomArRelativ: true,
          fromPer: 0,
          fromPerRelativ: true,
          tomPer: 0,
          tomPerRelativ: true,
          rullande: false,
          synlig: true,
        },
        {
          rubrik1: null,
          rubrik2: null,
          rubrik3: null,
          faltKod: 'DIFFPERUTGVARDEBUDGET',
          faltKodRubrik: null,
          resultatTyp: null,
          faltTyp: 3,
          intervallTyp: 0,
          bas: '1',
          antalDecimaler: 2,
          vandTecken: false,
          budgetTyp: 'A',
          budgetBenamning: null,
          fromAr: 0,
          fromArRelativ: true,
          tomAr: 0,
          tomArRelativ: true,
          fromPer: 0,
          fromPerRelativ: true,
          tomPer: 0,
          tomPerRelativ: true,
          rullande: false,
          synlig: true,
        },
        {
          rubrik1: null,
          rubrik2: null,
          rubrik3: null,
          faltKod: 'PROCENTPERUTGVARDEBUDGET',
          faltKodRubrik: null,
          resultatTyp: null,
          faltTyp: 3,
          intervallTyp: 0,
          bas: '1',
          antalDecimaler: 2,
          vandTecken: false,
          budgetTyp: 'A',
          budgetBenamning: null,
          fromAr: 0,
          fromArRelativ: true,
          tomAr: 0,
          tomArRelativ: true,
          fromPer: 0,
          fromPerRelativ: true,
          tomPer: 0,
          tomPerRelativ: true,
          rullande: false,
          synlig: true,
        },
        {
          rubrik1: null,
          rubrik2: null,
          rubrik3: null,
          faltKod: 'PERVARDE',
          faltKodRubrik: null,
          resultatTyp: null,
          faltTyp: 3,
          intervallTyp: 0,
          bas: '1',
          antalDecimaler: 2,
          vandTecken: false,
          budgetTyp: null,
          budgetBenamning: null,
          fromAr: -1,
          fromArRelativ: true,
          tomAr: -1,
          tomArRelativ: true,
          fromPer: 0,
          fromPerRelativ: true,
          tomPer: 0,
          tomPerRelativ: true,
          rullande: false,
          synlig: false,
        },
      ],
    },
    {
      category: 'Standard',
      name: 'Rullande tolv månader',
      canHavePrevYearCols: true,
      columns: [
        {
          rubrik1: null,
          rubrik2: null,
          rubrik3: null,
          faltKod: 'PERVARDE',
          faltKodRubrik: null,
          resultatTyp: null,
          faltTyp: 0,
          intervallTyp: 0,
          bas: '1',
          antalDecimaler: 2,
          vandTecken: false,
          budgetTyp: null,
          budgetBenamning: null,
          fromAr: 0,
          fromArRelativ: true,
          tomAr: 0,
          tomArRelativ: true,
          fromPer: -11,
          fromPerRelativ: true,
          tomPer: -11,
          tomPerRelativ: true,
          rullande: true,
          synlig: true,
        },
        {
          rubrik1: null,
          rubrik2: null,
          rubrik3: null,
          faltKod: 'PERVARDE',
          faltKodRubrik: null,
          resultatTyp: null,
          faltTyp: 0,
          intervallTyp: 0,
          bas: '1',
          antalDecimaler: 2,
          vandTecken: false,
          budgetTyp: null,
          budgetBenamning: null,
          fromAr: 0,
          fromArRelativ: true,
          tomAr: 0,
          tomArRelativ: true,
          fromPer: -10,
          fromPerRelativ: true,
          tomPer: -10,
          tomPerRelativ: true,
          rullande: true,
          synlig: true,
        },
        {
          rubrik1: null,
          rubrik2: null,
          rubrik3: null,
          faltKod: 'PERVARDE',
          faltKodRubrik: null,
          resultatTyp: null,
          faltTyp: 0,
          intervallTyp: 0,
          bas: '1',
          antalDecimaler: 2,
          vandTecken: false,
          budgetTyp: null,
          budgetBenamning: null,
          fromAr: 0,
          fromArRelativ: true,
          tomAr: 0,
          tomArRelativ: true,
          fromPer: -9,
          fromPerRelativ: true,
          tomPer: -9,
          tomPerRelativ: true,
          rullande: true,
          synlig: true,
        },
        {
          rubrik1: null,
          rubrik2: null,
          rubrik3: null,
          faltKod: 'PERVARDE',
          faltKodRubrik: null,
          resultatTyp: null,
          faltTyp: 0,
          intervallTyp: 0,
          bas: '1',
          antalDecimaler: 2,
          vandTecken: false,
          budgetTyp: null,
          budgetBenamning: null,
          fromAr: 0,
          fromArRelativ: true,
          tomAr: 0,
          tomArRelativ: true,
          fromPer: -8,
          fromPerRelativ: true,
          tomPer: -8,
          tomPerRelativ: true,
          rullande: true,
          synlig: true,
        },
        {
          rubrik1: null,
          rubrik2: null,
          rubrik3: null,
          faltKod: 'PERVARDE',
          faltKodRubrik: null,
          resultatTyp: null,
          faltTyp: 0,
          intervallTyp: 0,
          bas: '1',
          antalDecimaler: 2,
          vandTecken: false,
          budgetTyp: null,
          budgetBenamning: null,
          fromAr: 0,
          fromArRelativ: true,
          tomAr: 0,
          tomArRelativ: true,
          fromPer: -7,
          fromPerRelativ: true,
          tomPer: -7,
          tomPerRelativ: true,
          rullande: true,
          synlig: true,
        },
        {
          rubrik1: null,
          rubrik2: null,
          rubrik3: null,
          faltKod: 'PERVARDE',
          faltKodRubrik: null,
          resultatTyp: null,
          faltTyp: 0,
          intervallTyp: 0,
          bas: '1',
          antalDecimaler: 2,
          vandTecken: false,
          budgetTyp: null,
          budgetBenamning: null,
          fromAr: 0,
          fromArRelativ: true,
          tomAr: 0,
          tomArRelativ: true,
          fromPer: -6,
          fromPerRelativ: true,
          tomPer: -6,
          tomPerRelativ: true,
          rullande: true,
          synlig: true,
        },
        {
          rubrik1: null,
          rubrik2: null,
          rubrik3: null,
          faltKod: 'PERVARDE',
          faltKodRubrik: null,
          resultatTyp: null,
          faltTyp: 0,
          intervallTyp: 0,
          bas: '1',
          antalDecimaler: 2,
          vandTecken: false,
          budgetTyp: null,
          budgetBenamning: null,
          fromAr: 0,
          fromArRelativ: true,
          tomAr: 0,
          tomArRelativ: true,
          fromPer: -5,
          fromPerRelativ: true,
          tomPer: -5,
          tomPerRelativ: true,
          rullande: true,
          synlig: true,
        },
        {
          rubrik1: null,
          rubrik2: null,
          rubrik3: null,
          faltKod: 'PERVARDE',
          faltKodRubrik: null,
          resultatTyp: null,
          faltTyp: 0,
          intervallTyp: 0,
          bas: '1',
          antalDecimaler: 2,
          vandTecken: false,
          budgetTyp: null,
          budgetBenamning: null,
          fromAr: 0,
          fromArRelativ: true,
          tomAr: 0,
          tomArRelativ: true,
          fromPer: -4,
          fromPerRelativ: true,
          tomPer: -4,
          tomPerRelativ: true,
          rullande: true,
          synlig: true,
        },
        {
          rubrik1: null,
          rubrik2: null,
          rubrik3: null,
          faltKod: 'PERVARDE',
          faltKodRubrik: null,
          resultatTyp: null,
          faltTyp: 0,
          intervallTyp: 0,
          bas: '1',
          antalDecimaler: 2,
          vandTecken: false,
          budgetTyp: null,
          budgetBenamning: null,
          fromAr: 0,
          fromArRelativ: true,
          tomAr: 0,
          tomArRelativ: true,
          fromPer: -3,
          fromPerRelativ: true,
          tomPer: -3,
          tomPerRelativ: true,
          rullande: true,
          synlig: true,
        },
        {
          rubrik1: null,
          rubrik2: null,
          rubrik3: null,
          faltKod: 'PERVARDE',
          faltKodRubrik: null,
          resultatTyp: null,
          faltTyp: 0,
          intervallTyp: 0,
          bas: '1',
          antalDecimaler: 2,
          vandTecken: false,
          budgetTyp: null,
          budgetBenamning: null,
          fromAr: 0,
          fromArRelativ: true,
          tomAr: 0,
          tomArRelativ: true,
          fromPer: -2,
          fromPerRelativ: true,
          tomPer: -2,
          tomPerRelativ: true,
          rullande: true,
          synlig: true,
        },
        {
          rubrik1: null,
          rubrik2: null,
          rubrik3: null,
          faltKod: 'PERVARDE',
          faltKodRubrik: null,
          resultatTyp: null,
          faltTyp: 0,
          intervallTyp: 0,
          bas: '1',
          antalDecimaler: 2,
          vandTecken: false,
          budgetTyp: null,
          budgetBenamning: null,
          fromAr: 0,
          fromArRelativ: true,
          tomAr: 0,
          tomArRelativ: true,
          fromPer: -1,
          fromPerRelativ: true,
          tomPer: -1,
          tomPerRelativ: true,
          rullande: true,
          synlig: true,
        },
        {
          rubrik1: null,
          rubrik2: null,
          rubrik3: null,
          faltKod: 'PERVARDE',
          faltKodRubrik: null,
          resultatTyp: null,
          faltTyp: 0,
          intervallTyp: 0,
          bas: '1',
          antalDecimaler: 2,
          vandTecken: false,
          budgetTyp: null,
          budgetBenamning: null,
          fromAr: 0,
          fromArRelativ: true,
          tomAr: 0,
          tomArRelativ: true,
          fromPer: 0,
          fromPerRelativ: true,
          tomPer: 0,
          tomPerRelativ: true,
          rullande: true,
          synlig: true,
        },
      ],
    },
    {
      category: 'Standard',
      name: 'År',
      canHavePrevYearCols: false,
      columns: [
        {
          rubrik1: null,
          rubrik2: null,
          rubrik3: null,
          faltKod: 'ARETSINGBALANS',
          faltKodRubrik: null,
          resultatTyp: null,
          faltTyp: 0,
          intervallTyp: 0,
          bas: '1',
          antalDecimaler: 2,
          vandTecken: false,
          budgetTyp: null,
          budgetBenamning: null,
          fromAr: 0,
          fromArRelativ: true,
          tomAr: 0,
          tomArRelativ: true,
          fromPer: 0,
          fromPerRelativ: true,
          tomPer: 0,
          tomPerRelativ: true,
          rullande: false,
          synlig: true,
        },
        {
          rubrik1: null,
          rubrik2: null,
          rubrik3: null,
          faltKod: 'ARETSVARDE',
          faltKodRubrik: null,
          resultatTyp: null,
          faltTyp: 0,
          intervallTyp: 0,
          bas: '1',
          antalDecimaler: 2,
          vandTecken: false,
          budgetTyp: null,
          budgetBenamning: null,
          fromAr: 0,
          fromArRelativ: true,
          tomAr: 0,
          tomArRelativ: true,
          fromPer: 0,
          fromPerRelativ: true,
          tomPer: 0,
          tomPerRelativ: true,
          rullande: false,
          synlig: true,
        },
        {
          rubrik1: null,
          rubrik2: null,
          rubrik3: null,
          faltKod: 'ARETSVARDE',
          faltKodRubrik: null,
          resultatTyp: null,
          faltTyp: 1,
          intervallTyp: 0,
          bas: '1',
          antalDecimaler: 2,
          vandTecken: false,
          budgetTyp: null,
          budgetBenamning: null,
          fromAr: 0,
          fromArRelativ: true,
          tomAr: 0,
          tomArRelativ: true,
          fromPer: 0,
          fromPerRelativ: true,
          tomPer: 0,
          tomPerRelativ: true,
          rullande: false,
          synlig: false,
        },
        {
          rubrik1: null,
          rubrik2: null,
          rubrik3: null,
          faltKod: 'ARETSVARDE',
          faltKodRubrik: null,
          resultatTyp: null,
          faltTyp: 2,
          intervallTyp: 0,
          bas: '1',
          antalDecimaler: 2,
          vandTecken: false,
          budgetTyp: null,
          budgetBenamning: null,
          fromAr: 0,
          fromArRelativ: true,
          tomAr: 0,
          tomArRelativ: true,
          fromPer: 0,
          fromPerRelativ: true,
          tomPer: 0,
          tomPerRelativ: true,
          rullande: false,
          synlig: false,
        },
        {
          rubrik1: null,
          rubrik2: null,
          rubrik3: null,
          faltKod: 'ARETSUTGBALANS',
          faltKodRubrik: null,
          resultatTyp: null,
          faltTyp: 0,
          intervallTyp: 0,
          bas: '1',
          antalDecimaler: 2,
          vandTecken: false,
          budgetTyp: null,
          budgetBenamning: null,
          fromAr: 0,
          fromArRelativ: true,
          tomAr: 0,
          tomArRelativ: true,
          fromPer: 0,
          fromPerRelativ: true,
          tomPer: 0,
          tomPerRelativ: true,
          rullande: false,
          synlig: true,
        },
        {
          rubrik1: null,
          rubrik2: null,
          rubrik3: null,
          faltKod: 'ARETSBUDGET',
          faltKodRubrik: null,
          resultatTyp: null,
          faltTyp: 0,
          intervallTyp: 0,
          bas: '1',
          antalDecimaler: 2,
          vandTecken: false,
          budgetTyp: 'A',
          budgetBenamning: null,
          fromAr: 0,
          fromArRelativ: true,
          tomAr: 0,
          tomArRelativ: true,
          fromPer: 0,
          fromPerRelativ: true,
          tomPer: 0,
          tomPerRelativ: true,
          rullande: false,
          synlig: true,
        },
        {
          rubrik1: null,
          rubrik2: null,
          rubrik3: null,
          faltKod: 'DIFFARETSVARDEBUDGET',
          faltKodRubrik: null,
          resultatTyp: null,
          faltTyp: 0,
          intervallTyp: 0,
          bas: '1',
          antalDecimaler: 2,
          vandTecken: false,
          budgetTyp: 'A',
          budgetBenamning: null,
          fromAr: 0,
          fromArRelativ: true,
          tomAr: 0,
          tomArRelativ: true,
          fromPer: 0,
          fromPerRelativ: true,
          tomPer: 0,
          tomPerRelativ: true,
          rullande: false,
          synlig: true,
        },
        {
          rubrik1: null,
          rubrik2: null,
          rubrik3: null,
          faltKod: 'PROCENTARETSVARDEBUDGET',
          faltKodRubrik: null,
          resultatTyp: null,
          faltTyp: 0,
          intervallTyp: 0,
          bas: '1',
          antalDecimaler: 2,
          vandTecken: false,
          budgetTyp: 'A',
          budgetBenamning: null,
          fromAr: 0,
          fromArRelativ: true,
          tomAr: 0,
          tomArRelativ: true,
          fromPer: 0,
          fromPerRelativ: true,
          tomPer: 0,
          tomPerRelativ: true,
          rullande: false,
          synlig: true,
        },
        {
          rubrik1: null,
          rubrik2: null,
          rubrik3: null,
          faltKod: 'ARETSVARDE',
          faltKodRubrik: null,
          resultatTyp: null,
          faltTyp: 0,
          intervallTyp: 0,
          bas: '1',
          antalDecimaler: 2,
          vandTecken: false,
          budgetTyp: null,
          budgetBenamning: null,
          fromAr: -1,
          fromArRelativ: true,
          tomAr: -1,
          tomArRelativ: true,
          fromPer: 0,
          fromPerRelativ: true,
          tomPer: 0,
          tomPerRelativ: true,
          rullande: false,
          synlig: false,
        },
      ],
    },
    //Pågående inv
    {
      category: 'Standard',
      name: 'Pågående investeringar',
      canHavePrevYearCols: false,
      columns: [
        {
          rubrik1: null,
          rubrik2: null,
          rubrik3: null,
          faltKod: 'ING_PAGINV_TOTALT',
          faltKodRubrik: null,
          resultatTyp: null,
          faltTyp: 0,
          intervallTyp: 0,
          bas: '1',
          antalDecimaler: 2,
          vandTecken: false,
          budgetTyp: null,
          budgetBenamning: null,
          fromAr: 0,
          fromArRelativ: true,
          tomAr: 0,
          tomArRelativ: true,
          fromPer: 0,
          fromPerRelativ: true,
          tomPer: 0,
          tomPerRelativ: true,
          rullande: false,
          synlig: false,
        },
        {
          rubrik1: null,
          rubrik2: null,
          rubrik3: null,
          faltKod: 'PER_PAGINV_TOTALT',
          faltKodRubrik: null,
          resultatTyp: null,
          faltTyp: 0,
          intervallTyp: 0,
          bas: '1',
          antalDecimaler: 2,
          vandTecken: false,
          budgetTyp: null,
          budgetBenamning: null,
          fromAr: 0,
          fromArRelativ: true,
          tomAr: 0,
          tomArRelativ: true,
          fromPer: 0,
          fromPerRelativ: true,
          tomPer: 0,
          tomPerRelativ: true,
          rullande: false,
          synlig: false,
        },
        {
          rubrik1: null,
          rubrik2: null,
          rubrik3: null,
          faltKod: 'ACK_PAGINV_TOTALT',
          faltKodRubrik: null,
          resultatTyp: null,
          faltTyp: 0,
          intervallTyp: 0,
          bas: '1',
          antalDecimaler: 2,
          vandTecken: false,
          budgetTyp: null,
          budgetBenamning: null,
          fromAr: 0,
          fromArRelativ: true,
          tomAr: 0,
          tomArRelativ: true,
          fromPer: 0,
          fromPerRelativ: true,
          tomPer: 0,
          tomPerRelativ: true,
          rullande: false,
          synlig: true,
        },
        {
          rubrik1: null,
          rubrik2: null,
          rubrik3: null,
          faltKod: 'ING_PAGINV_AKTIVERAT',
          faltKodRubrik: null,
          resultatTyp: null,
          faltTyp: 0,
          intervallTyp: 0,
          bas: '1',
          antalDecimaler: 2,
          vandTecken: false,
          budgetTyp: null,
          budgetBenamning: null,
          fromAr: 0,
          fromArRelativ: true,
          tomAr: 0,
          tomArRelativ: true,
          fromPer: 0,
          fromPerRelativ: true,
          tomPer: 0,
          tomPerRelativ: true,
          rullande: false,
          synlig: false,
        },
        {
          rubrik1: null,
          rubrik2: null,
          rubrik3: null,
          faltKod: 'PER_PAGINV_AKTIVERAT',
          faltKodRubrik: null,
          resultatTyp: null,
          faltTyp: 0,
          intervallTyp: 0,
          bas: '1',
          antalDecimaler: 2,
          vandTecken: false,
          budgetTyp: null,
          budgetBenamning: null,
          fromAr: 0,
          fromArRelativ: true,
          tomAr: 0,
          tomArRelativ: true,
          fromPer: 0,
          fromPerRelativ: true,
          tomPer: 0,
          tomPerRelativ: true,
          rullande: false,
          synlig: false,
        },
        {
          rubrik1: null,
          rubrik2: null,
          rubrik3: null,
          faltKod: 'ACK_PAGINV_AKTIVERAT',
          faltKodRubrik: null,
          resultatTyp: null,
          faltTyp: 0,
          intervallTyp: 0,
          bas: '1',
          antalDecimaler: 2,
          vandTecken: false,
          budgetTyp: null,
          budgetBenamning: null,
          fromAr: 0,
          fromArRelativ: true,
          tomAr: 0,
          tomArRelativ: true,
          fromPer: 0,
          fromPerRelativ: true,
          tomPer: 0,
          tomPerRelativ: true,
          rullande: false,
          synlig: true,
        },
        {
          rubrik1: null,
          rubrik2: null,
          rubrik3: null,
          faltKod: 'ING_PAGINV_OMBOKF',
          faltKodRubrik: null,
          resultatTyp: null,
          faltTyp: 0,
          intervallTyp: 0,
          bas: '1',
          antalDecimaler: 2,
          vandTecken: false,
          budgetTyp: null,
          budgetBenamning: null,
          fromAr: 0,
          fromArRelativ: true,
          tomAr: 0,
          tomArRelativ: true,
          fromPer: 0,
          fromPerRelativ: true,
          tomPer: 0,
          tomPerRelativ: true,
          rullande: false,
          synlig: false,
        },
        {
          rubrik1: null,
          rubrik2: null,
          rubrik3: null,
          faltKod: 'PER_PAGINV_OMBOKF',
          faltKodRubrik: null,
          resultatTyp: null,
          faltTyp: 0,
          intervallTyp: 0,
          bas: '1',
          antalDecimaler: 2,
          vandTecken: false,
          budgetTyp: null,
          budgetBenamning: null,
          fromAr: 0,
          fromArRelativ: true,
          tomAr: 0,
          tomArRelativ: true,
          fromPer: 0,
          fromPerRelativ: true,
          tomPer: 0,
          tomPerRelativ: true,
          rullande: false,
          synlig: false,
        },
        {
          rubrik1: null,
          rubrik2: null,
          rubrik3: null,
          faltKod: 'ACK_PAGINV_OMBOKF',
          faltKodRubrik: null,
          resultatTyp: null,
          faltTyp: 0,
          intervallTyp: 0,
          bas: '1',
          antalDecimaler: 2,
          vandTecken: false,
          budgetTyp: null,
          budgetBenamning: null,
          fromAr: 0,
          fromArRelativ: true,
          tomAr: 0,
          tomArRelativ: true,
          fromPer: 0,
          fromPerRelativ: true,
          tomPer: 0,
          tomPerRelativ: true,
          rullande: false,
          synlig: true,
        },
        {
          rubrik1: null,
          rubrik2: null,
          rubrik3: null,
          faltKod: 'ING_PAGINV_PAGAENDE',
          faltKodRubrik: null,
          resultatTyp: null,
          faltTyp: 0,
          intervallTyp: 0,
          bas: '1',
          antalDecimaler: 2,
          vandTecken: false,
          budgetTyp: null,
          budgetBenamning: null,
          fromAr: 0,
          fromArRelativ: true,
          tomAr: 0,
          tomArRelativ: true,
          fromPer: 0,
          fromPerRelativ: true,
          tomPer: 0,
          tomPerRelativ: true,
          rullande: false,
          synlig: false,
        },
        {
          rubrik1: null,
          rubrik2: null,
          rubrik3: null,
          faltKod: 'PER_PAGINV_PAGAENDE',
          faltKodRubrik: null,
          resultatTyp: null,
          faltTyp: 0,
          intervallTyp: 0,
          bas: '1',
          antalDecimaler: 2,
          vandTecken: false,
          budgetTyp: null,
          budgetBenamning: null,
          fromAr: 0,
          fromArRelativ: true,
          tomAr: 0,
          tomArRelativ: true,
          fromPer: 0,
          fromPerRelativ: true,
          tomPer: 0,
          tomPerRelativ: true,
          rullande: false,
          synlig: false,
        },
        {
          rubrik1: null,
          rubrik2: null,
          rubrik3: null,
          faltKod: 'ACK_PAGINV_PAGAENDE',
          faltKodRubrik: null,
          resultatTyp: null,
          faltTyp: 0,
          intervallTyp: 0,
          bas: '1',
          antalDecimaler: 2,
          vandTecken: false,
          budgetTyp: null,
          budgetBenamning: null,
          fromAr: 0,
          fromArRelativ: true,
          tomAr: 0,
          tomArRelativ: true,
          fromPer: 0,
          fromPerRelativ: true,
          tomPer: 0,
          tomPerRelativ: true,
          rullande: false,
          synlig: true,
        },
        {
          rubrik1: null,
          rubrik2: null,
          rubrik3: null,
          faltKod: 'ING_PAGINV_UTANFOR',
          faltKodRubrik: null,
          resultatTyp: null,
          faltTyp: 0,
          intervallTyp: 0,
          bas: '1',
          antalDecimaler: 2,
          vandTecken: false,
          budgetTyp: null,
          budgetBenamning: null,
          fromAr: 0,
          fromArRelativ: true,
          tomAr: 0,
          tomArRelativ: true,
          fromPer: 0,
          fromPerRelativ: true,
          tomPer: 0,
          tomPerRelativ: true,
          rullande: false,
          synlig: false,
        },
        {
          rubrik1: null,
          rubrik2: null,
          rubrik3: null,
          faltKod: 'PER_PAGINV_UTANFOR',
          faltKodRubrik: null,
          resultatTyp: null,
          faltTyp: 0,
          intervallTyp: 0,
          bas: '1',
          antalDecimaler: 2,
          vandTecken: false,
          budgetTyp: null,
          budgetBenamning: null,
          fromAr: 0,
          fromArRelativ: true,
          tomAr: 0,
          tomArRelativ: true,
          fromPer: 0,
          fromPerRelativ: true,
          tomPer: 0,
          tomPerRelativ: true,
          rullande: false,
          synlig: false,
        },
        {
          rubrik1: null,
          rubrik2: null,
          rubrik3: null,
          faltKod: 'ACK_PAGINV_UTANFOR',
          faltKodRubrik: null,
          resultatTyp: null,
          faltTyp: 0,
          intervallTyp: 0,
          bas: '1',
          antalDecimaler: 2,
          vandTecken: false,
          budgetTyp: null,
          budgetBenamning: null,
          fromAr: 0,
          fromArRelativ: true,
          tomAr: 0,
          tomArRelativ: true,
          fromPer: 0,
          fromPerRelativ: true,
          tomPer: 0,
          tomPerRelativ: true,
          rullande: false,
          synlig: false,
        },
      ],
    },
  ],
};
